function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './CardMultiple.css';
import React, { useEffect } from 'react';
import debounce from 'lodash/debounce';
import { canUseDOM } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import { CardMultipleCard } from './components/CardMultipleCard/CardMultipleCard';
import { isNil, isNotNil } from '../../utils/IsNil';
import { sleep } from '../../utils/Sleep';
import { get } from '../../utils/getPropertyByPath';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
const checkForExistingCardsPreview = cardMultipleWrapperId => {
  const allExistingCards = Array.from(cardMultipleWrapperId.getElementsByClassName("nextNotActiveCarouselItem"));
  if (isNotNil(allExistingCards)) {
    allExistingCards.forEach(card => {
      card.remove();
    });
  }
};
const getCardPreview = async uniqueId => {
  const cardMultipleWrapperId = document.getElementById(uniqueId); // handle unique container if we have more than 1 CardMultiple on the page
  if (isNil(cardMultipleWrapperId)) {
    return null;
  }
  checkForExistingCardsPreview(cardMultipleWrapperId);
  const isTablet = window.matchMedia(`(max-width: 1200px)`).matches;
  if (canUseDOM && isTablet) {
    return null;
  }
  await sleep(300); // not visible item become active for this time 300ms
  const allActiveElements = cardMultipleWrapperId.querySelectorAll(".react-multi-carousel-item--active");
  const lastActiveCarouselItem = allActiveElements[allActiveElements.length - 1];
  if (isNil(lastActiveCarouselItem)) {
    return null;
  }
  const nextNotActiveCarouselItem = lastActiveCarouselItem.nextSibling;
  if (isNil(nextNotActiveCarouselItem)) {
    return null;
  }
  const clone = nextNotActiveCarouselItem.cloneNode(true);
  clone.classList.add("nextNotActiveCarouselItem");
  cardMultipleWrapperId.appendChild(clone);
};
const CardMultiple = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);

  // id for correct work of preview card in carousel
  const text = get(fields, "data.datasource.text");
  const heading = get(fields, "data.datasource.heading");
  const items = get(fields, "data.datasource.items", []);
  const id = get(fields, "data.datasource.id");
  const headingValue = get(heading, "jss.value");
  const textValue = get(text, "jss.value");
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const analyticsButtonClick = text => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['nextAndPreviousAnalytics'], params), text);
  };
  const carouselInteractionButtonNameAnalytics = textArray => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['carouselInteractionButtonNameAnalytics'], params), textArray);
  };
  useEffect(() => {
    setTimeout(() => {
      getCardPreview(id);
    }, 300);
    window.addEventListener('resize', debounce(() => getCardPreview(id), 300));
    return () => {
      window.removeEventListener('resize', () => getCardPreview(id));
    };
  }, []);
  if (isNil(fields) || isNil(fields.data) || isNil(fields.data.datasource)) {
    console.warn('CardMultiple component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [CardMultiple component is empty: please provide data source]");
    }
    return null;
  }
  const renderItems = () => items.map((item, index) => {
    return /*#__PURE__*/React.createElement(CardMultipleCard, _extends({
      analyticsHandler: carouselInteractionButtonNameAnalytics
    }, item));
  });
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "descriptionWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "descriptionHeading"
  }, headingValue), textValue && /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: textValue
    },
    className: "descriptionTextt"
  })), /*#__PURE__*/React.createElement(CarouselProvider, null, _ref2 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots
    } = _ref2;
    return /*#__PURE__*/React.createElement("div", {
      className: "carouselWrapper",
      id: id
    }, /*#__PURE__*/React.createElement("div", {
      className: "buttons"
    }, items.length > 3 ? /*#__PURE__*/React.createElement(React.Fragment, null, renderPreviousButton(() => {
      analyticsButtonClick("previous");
      getCardPreview(id);
    }, true), renderNextButton(() => {
      analyticsButtonClick("next");
      getCardPreview(id);
    }, true)) : null), /*#__PURE__*/React.createElement(React.Fragment, null, renderCarousel(renderItems(), {
      responsive: {
        max: {
          breakpoint: {
            max: 10000,
            min: 1441
          },
          items: 3
        },
        desktop: {
          breakpoint: {
            max: 1440,
            min: 768
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 767,
            min: 0
          },
          items: 1
        }
      },
      containerClass: items.length > 3 ? "carouselContainer carouselContainerWithMaxWidth64" : "carouselContainer carouselContainerWithMaxWidth100"
    })), /*#__PURE__*/React.createElement("div", {
      className: "paginationDots"
    }, renderDots()));
  }));
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref3;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`,
    anchorUrlParameter: anchorUrlParameter
  }, children);
};
const commonStyles = "c1tssnbe";
const ltrStyles = "l1awtyvq";
const rtlStyles = "rg62f";
export default CardMultiple;